import balanceDetails from './balanceDetails'
import balanceDue from './balanceDue'
import bulkAvailablePaymentTypes from './bulkAvailablePaymentTypes'
import cid from './cid'
import customContent from './customContent'
import errors from './errors'
import loading from './loading'
import offline from './offline'
import permissionNotice from './permissionNotice'
import cookiesNotice from './cookiesNotice'
import productPermissions from './productPermissions'
import propertyAssociation from './propertyAssociation'
import propertyContacts from './propertyContacts'
import settings from './settings'
import states from './states'
import websiteId from './websiteId'
import showDropDown from './toggleUnitDropDown'
import userModuleModals from './toggleSuccessModals'
import privacyPolicies from './privacyPolicies'
import leasePermissions from './leasePermissions'
import bulkPaymentsList from './bulkPaymentsList'
import bulkPaymentsListModal from './bulkPaymentsListModal'
import { default as bulkPayment } from 'portal-modules/payments/components/bulk-payments/redux/modules/bulkPayment'

export default {
  balanceDetails,
  balanceDue,
  bulkAvailablePaymentTypes,
  cid,
  customContent,
  errors,
  loading,
  offline,
  permissionNotice,
  cookiesNotice,
  productPermissions,
  propertyContacts,
  settings,
  states,
  websiteId,
  showDropDown,
  userModuleModals,
  privacyPolicies,
  leasePermissions,
  bulkPaymentsList,
  bulkPaymentsListModal,
  bulkPayment,
  propertyAssociation,
}
